import { Component } from '@angular/core';

@Component({
  selector: 'app-qr-small',
  templateUrl: './qr-small.component.html',
  styleUrls: ['./qr-small.component.scss']
})
export class QrSmallComponent {

}
